import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export function ImageStripEmptyPlaceholder({
    children,
    invalid = false,
    onClick,
}: {
    children: ReactNode;
    invalid?: boolean;
    onClick: () => void;
}) {
    return (
        <button
            type="button"
            className={cn(
                "flex min-h-[250px] w-full cursor-pointer items-center justify-center rounded-md border-2 border-zinc-100 border-dashed bg-transparent px-4 transition-colors hover:border-zinc-300 hover:bg-zinc-100",
                invalid &&
                    "border-red-200 bg-red-50 hover:border-red-200 hover:bg-red-50",
            )}
            onClick={(event) => {
                event.stopPropagation();
                onClick();
            }}
        >
            {children}
        </button>
    );
}
